import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

function AwarenessProgramOnCybercrime() {

    const images = [
        "1000399717.jpg",
        "1000399843.jpg",
        "1000399844.jpg",
        "1000399851.jpg",
    ];

    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className='pb-2'>
                                        Awareness Program on Cybercrime
                                    </h2>

                                    <p>
                                        An awareness program on Cybercrime and cybersecurity by SI Aksheeta from Gachibowli police station in collaboration with Eenadu.
                                    </p>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {images.map((img, index) => (
                                                <div className="col-md-6 mb-3 mb-lg-4" key={index}>
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Awareness-Program-on-Cybercrime/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Awareness-Program-on-Cybercrime/${img}`}
                                                            alt={`Cybercrime Awareness Program Image ${index + 1}`}
                                                            className="img-responsive center-block rounded overflow-hidden"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default AwarenessProgramOnCybercrime;
